export default __webpack_public_path__ + "static/media/Transition_Start-Managed-Services.9d5fbd02.mp4";